import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

const publicPages = [
  '/auth/login',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
];

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  async (config) => {
    if (!publicPages.includes(window.location.pathname)) {
      const token = localStorage.getItem('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const baseApi = axios.create({
  baseURL: API_URL,
});

export default api;
